module.exports = __webpack_public_path__ + "img/step-1.49f51cbc.svg";